import { render } from "./GatewayAddForm.vue?vue&type=template&id=25598e40"
import script from "./GatewayAddForm.vue?vue&type=script&lang=js"
export * from "./GatewayAddForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__